import React, { Component } from "react";
import image from "../../../assets/images/callgage-about-header.jpg";
import fadedLogo from "../../../assets/images/callgage-about-us-faded-logo.png";
import "../../../styles/pages/about/AboutHeader.css";

export default class AboutHeader extends Component {
  render() {
    return (
      <div className="AboutHeader">
        {/* The Text Container */}
        <div className="text-container on-scroll-anim">
          {/* The Faded Background Logo */}
          <img src={fadedLogo} className="logo" alt="Callgage logo" />

          {/* The Actual Text */}
          <div className="title-container on-scroll-anim">
            <div className="g-title desktop">WHO ARE WE?</div>
          </div>
          <div className="g-sub-text">
            We are a web design duo, childhood friends, and terrible ping pong
            players. Together we manage every aspect of our business, from
            creative work, to sales.
            <br />
            <br />
            On an average day you can find us out taking photos for a project,
            getting mad at the A.I. in Super Mario Kart, or speculating about
            the future of the internet.
          </div>
        </div>

        {/* The Image */}
        <div className="image-container on-scroll-anim">
          <img
            className="d-rock"
            src={image}
            draggable="false"
            alt="Derek posing in front of a sick statue!"
          />
        </div>
        <div className="title-container on-scroll-anim">
          <div className="g-title mobile on-scroll-anim">WHO ARE WE?</div>
        </div>
      </div>
    );
  }
}
